import type { UncontrolledComboBoxItem } from '../ComboBox/UncontrolledComboBox';

const COUNTRIES: UncontrolledComboBoxItem[] = [
  {
    id: 'de',
    name: 'Deutschland',
  },
  {
    id: 'at',
    name: 'Österreich',
  },
];

export default COUNTRIES;
